import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
export default class default_1 extends Controller {
    connect() {
        let flatpickerOptions = Object.assign({
            minDate: "today",
            monthSelectorType: "static",
            inline: true,
            altInput: false,
            allowInput: false,
            disableMobile: true,
            altFormat: "l, F j, Y",
            dateFormat: "Y-m-d",
            // enable: [],
            // onMonthChange(selectedDates, value, instance, data) {
            //   console.log(instance);
            // },
        }, this.optionsValue);
        flatpickr(this.element, flatpickerOptions);
        //this.element.removeAttribute("readonly");
    }
}
default_1.values = {
    options: Object,
};
